import { useQuery } from '@tanstack/react-query';
import { axios } from '@/request-clients/axios';
import { criticalQueryRetry } from '@/request-clients/query-retry';
import { useMsalAccount } from '@/auth/use-msal-account';
import { ChatCredentialsWithChannelInfoResult } from '@my-ipractice/types';

export const useGetChatCredentials = (props?: {
  onSuccess?: (data: ChatCredentialsWithChannelInfoResult) => void;
}) => {
  const { isMsalAccountReady } = useMsalAccount();

  return useQuery<ChatCredentialsWithChannelInfoResult>({
    queryFn: async () => {
      const url = `clients/chat/credentials-with-channel-info`;
      const response = await axios.get(url);

      if (props?.onSuccess) {
        props.onSuccess(response.data);
      }

      return response.data;
    },
    enabled: isMsalAccountReady,
    ...criticalQueryRetry,
    queryKey: ['chat-credentials-with-channel-info'],
    meta: {
      errorMessage: 'Error fetching chat credentials',
    },
  });
};
